import loggerMiddleware from './logger'
import mfaEnforcedMiddleware from './mfaEnforcedRedirect'
import firstPageMiddleware from './firstPageMarker'

const middlewares = [firstPageMiddleware, mfaEnforcedMiddleware]

if (__LOGGER_ACTIVE__) {
  middlewares.push(loggerMiddleware)
}

export default middlewares
